import React, { useEffect, useState } from 'react';

// API/Components
import { ANALYSIS_TYPE, isEmpty, formatDateTime } from './enums';
import { BuildDataGridMeasurementCell } from './ui_helpers';
import NoItemsOverlay from '../components/no_items_overlay';

// Material UI
import { DataGrid } from '@mui/x-data-grid';


// Unit Snapshot Report table columns
const columns = [
	{
		field: 'datetime',
		headerName: 'Measurement',
		description: 'Measurement Date and Time',
		minWidth: 170,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => formatDateTime(params.value),
	},
	{
		field: 'voltage',
		headerName: 'Voltage',
		description: 'Unit Voltage',
		minWidth: 190,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.VOLTAGE),
	},
	{
		field: 'impedance',
		headerName: 'Impedance',
		description: 'Unit Impedance',
		minWidth: 190,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.IMPEDANCE),
	},
	{
		field: 'temperature',
		headerName: 'Temp',
		description: 'Unit Temperature',
		minWidth: 190,
		flex: 1,
		headerAlign: "left",
		renderCell: (params) => BuildDataGridMeasurementCell(params.value, ANALYSIS_TYPE.TEMPERATURE),
	},
];


export default function UnitTrendReport(props) {
	const { trendData, loading } = props;
	
	const [reportTrendData, setReportTrendData] = useState([]);
	const [isLoading, setIsLoading] = useState(loading);
	const [pageSize, setPageSize] = useState(50);
	
	useEffect(() => {
		const formattedData = FormatDataForReport(trendData);
		if (formattedData !== undefined && formattedData !== null) {
			var newestAtTop = formattedData.reverse();
			setReportTrendData(newestAtTop);
		}
	}, [trendData]);

	useEffect(() => {
		setIsLoading(loading);
	}, [loading]);
	
	function FormatDataForReport(trendData) {
		setIsLoading(true);
		let rows = [];
		if (trendData !== null && trendData !== undefined && !isEmpty(trendData)) {
			trendData.forEach(meas => {
				rows.push({
					datetime: meas.measurement_date,
					voltage: {
						measurement: meas.measurement.unit_voltage,
						result: meas.analysis.voltage_analysis_result,
						out: meas.analysis.voltage_analysis_out,
						valid: meas.analysis.voltage_analysis_valid,
					},
					impedance: {
						measurement: meas.measurement.unit_imp,
						result: meas.analysis.impedance_analysis_result,
						out: meas.analysis.impedance_analysis_out,
						valid: meas.analysis.impedance_analysis_valid,
					},
					temperature: {
						measurement: meas.measurement.unit_temp,
						result: meas.analysis.temperature_analysis_result,
						out: meas.analysis.temperature_analysis_out,
						valid: meas.analysis.temperature_analysis_valid,
					},
				});
			});
		}
		
		setIsLoading(false);
		return rows;
	}
	
	return (
		<DataGrid
			getRowId={(row) => `${row.datetime}`}
			rows={reportTrendData}
			columns={columns}
			loading={isLoading}
			density="compact"
			pageSize={pageSize}
			onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
			pageSizeOptions={[25, 50, 100]}  // Max pagination size for DataGrid (Free Edition) is 100
			slots={{
				noRowsOverlay: NoItemsOverlay,
			}}
			slotProps={{
				noRowsOverlay: { noItemsText: 'No Unit Trend Data' },
			}}
			sx={{
				padding: 1,
				height: '100%'
			}}
		/>
	);
}